import { Group } from './types';

export const GROUPS: Group[] = [
  {
    name: 'format',
    title: 'Formatar',
    commands: [
      {
        name: 'heading1',
        label: 'Título',
        iconName: 'Heading1',
        description: 'Título da seção de alta prioridade',
        aliases: ['h1'],
        action: (editor) => {
          editor.chain().focus().setHeading({ level: 1 }).run();
        },
      },
      {
        name: 'bulletList',
        label: 'Lista de marcadores',
        iconName: 'List',
        description: 'Lista desordenada de itens',
        aliases: ['ul'],
        action: (editor) => {
          editor.chain().focus().toggleBulletList().run();
        },
      },
      {
        name: 'numberedList',
        label: 'Lista numerada',
        iconName: 'ListOrdered',
        description: 'Lista ordenada de itens',
        aliases: ['ol'],
        action: (editor) => {
          editor.chain().focus().toggleOrderedList().run();
        },
      },
      {
        name: 'taskList',
        label: 'Lista de tarefas',
        iconName: 'ListTodo',
        description: 'Lista de tarefas com itens a fazer',
        aliases: ['todo'],
        action: (editor) => {
          editor.chain().focus().toggleTaskList().run();
        },
      },
      {
        name: 'blockquote',
        label: 'Citação em bloco',
        iconName: 'Quote',
        description: 'Elemento para citação',
        action: (editor) => {
          editor.chain().focus().setBlockquote().run();
        },
      },
    ],
  },
  {
    name: 'insert',
    title: 'Inserir',
    commands: [
      {
        name: 'stepper',
        label: 'Régua de tramitação',
        iconName: 'Workflow',
        description: 'Inserir uma régua de tramitação',
        shouldBeHidden: (editor) => editor.isActive('stepper'),
        action: (editor) => {
          editor.chain().focus().insertSteps().run();
        },
      },
      {
        name: 'table',
        label: 'Tabela',
        iconName: 'Table',
        description: 'Inserir uma tabela',
        shouldBeHidden: (editor) => editor.isActive('columns'),
        action: (editor) => {
          editor
            .chain()
            .focus()
            .insertTable({ rows: 3, cols: 3, withHeaderRow: false })
            .run();
        },
      },
      {
        name: 'image',
        label: 'Imagem',
        iconName: 'Image',
        description: 'Inserir uma imagem',
        aliases: ['img'],
        action: (editor) => {
          editor.chain().focus().setImageUpload().run();
        },
      },
      {
        name: 'chart',
        label: 'Gráfico',
        iconName: 'ChartPie',
        description: 'Inserir um gráfico personalizável',
        aliases: ['grafico', 'chart', 'pie', 'bar'],
        action: (editor) => {
          editor.chain().focus().insertChart().run();
        },
      },
      {
        name: 'columns',
        label: 'Colunas',
        iconName: 'Columns2',
        description: 'Adicionar conteúdo de duas colunas',
        aliases: ['cols'],
        shouldBeHidden: (editor) => editor.isActive('columns'),
        action: (editor) => {
          editor
            .chain()
            .focus()
            .setColumns()
            .focus(editor.state.selection.head - 1)
            .run();
        },
      },
      {
        name: 'highlightBlock',
        label: 'Bloco de destaque',
        iconName: 'Highlighter',
        description: 'Adicionar conteúdo em destaque',
        aliases: ['hblock'],
        shouldBeHidden: (editor) => editor.isActive('highlightBlock'),
        action: (editor) => {
          editor
            .chain()
            .focus()
            .insertBlock()
            .focus(editor.state.selection.head - 1)
            .run();
        },
      },
      {
        name: 'horizontalRule',
        label: 'Régua horizontal',
        iconName: 'Minus',
        description: 'Insira um divisor horizontal',
        aliases: ['hr'],
        action: (editor) => {
          editor.chain().focus().setHorizontalRule().run();
        },
      },
    ],
  },
];

export default GROUPS;
